import taskApi from '../../api/task'

// initial state
const state = {
  items: []
}

// getters
const getters = {
}

// actions
const actions = {
  markComplete ({ dispatch, commit }, taskObject) {
    return new Promise((resolve, reject) => {
      taskApi.markComplete(taskObject.id, tasks => {
        const message = `You've completed ${ taskObject.taskName }!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        dispatch('setTasks', tasks)
        resolve() // tell the action-caller that this is done now
        },
        error => {
          const message = `Something went wrong updating that task...`
          dispatch('global/showSnackbarError', { message: message }, { root: true })
          reject() // tell the action-caller that this [failed] now
      })
    })
  },
  setTasks ({ commit }, tasks) {
    commit('setTasks', tasks)
  },

  markIncomplete ({ dispatch, commit }, taskObject) {
    return new Promise((resolve, reject) => {
      taskApi.markIncomplete(taskObject.id, tasks => {
        const message = `You've marked ${ taskObject.taskName } as incomplete!`
        dispatch('global/showSnackbarSuccess', { message: message }, { root: true })
        commit('setTasks', tasks)
        resolve()
      },
      error => {
        const message = `Something went wrong updating that task...`
        dispatch('global/showSnackbarError', { message: message }, { root: true })
        reject()
      })
    })
  },
}

// mutations
const mutations = {
  setTasks (state, tasks) {
    state.items = tasks
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
